<template>
    <span><el-checkbox v-model="value" disabled></el-checkbox></span>
</template>

<script>
export default {
    props: ['value'],
};
</script>



// WEBPACK FOOTER //
// Boolean.vue?7466a773